import {
  SubContractStateTypes,
  SubContractActionTypes,
} from "./SubContract.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: SubContractStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const SubContractReducer = (
  state: SubContractStateTypes = INITIAL_STATE,
  action: any
): SubContractStateTypes => {
  switch (action.type) {
    case SubContractActionTypes.FETCH_ALL_SUB_CONTRACT:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case SubContractActionTypes.FETCH_ALL_SUB_CONTRACT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case SubContractActionTypes.FETCH_ALL_SUB_CONTRACT_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case SubContractActionTypes.FETCH_ALL_SUB_CONTRACT_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case SubContractActionTypes.FETCH_ONE_SUB_CONTRACT:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: null,
          isPending: true,
          isSuccessful: false,
        },
      };
    case SubContractActionTypes.FETCH_ONE_SUB_CONTRACT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState({}),
      };
    case SubContractActionTypes.FETCH_ONE_SUB_CONTRACT_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: null,
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case SubContractActionTypes.FETCH_ONE_SUB_CONTRACT_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default SubContractReducer;
